import React from 'react';
import { withDefaultStyles, PropsWithDefaultStyle } from '@bingads-webui-react/with-default-styles';
import { getStyles } from './getStyles';
import { IUiBlockerProps } from './types';

const UiBlockerUnthemed = (props: PropsWithDefaultStyle<IUiBlockerProps>) => {
  const {
    blocking,
    children,
    loadingText,
  } = props;

  const classes = blocking ? `${props.classes.reactBlockUi} react-block-ui` : 'react-block-ui-none';

  return (
    <div className={classes} aria-busy={blocking}>
      {children}
      {blocking && (
        <div className={props.classes.blockUiContainer}>
          <div className={props.classes.blockUiOverlay}>
            <div
              className={props.classes.blockerIndicator}
              role="status"
              aria-label={loadingText}
            >
              <div className="blocker-image" />
              <div className="blocker-text">
                {loadingText}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export const UiBlocker = withDefaultStyles(UiBlockerUnthemed, getStyles);
